import { emptyCateringOptions } from '@/modules/public/enquiry-form/misc/cateringOptions';

export const trackingMapFieldToLabel = (name) => {
  switch (name) {
    case 'fullName':
      return 'name';
    case 'flexibleOnTime':
      return 'flexible';
    case 'timeFrom':
    case 'timeTo':
      return 'time';
    case 'requireCatering':
      return 'catering';
    case 'ownCatering':
      return 'externalCatering';
    case 'breakfast':
    case 'teaAndCoffee':
    case 'lunch':
    case 'dinner':
    case 'drinksReception':
    case 'other':
      return 'cateringOptions';
    default:
      return name;
  }
};

const mapField = (name, fields, isError = false) => {
  if (typeof fields[name] === 'undefined') {
    return {};
  }
  const parseError = (value) => {
    if (!isError) {
      return value;
    }
    return Array.isArray(value) ? !!value.length : value;
  };

  switch (name) {
    case 'fullName':
      if (isError) {
        return {
          name: parseError(fields.fullName),
        };
      }
      return {
        name: fields.fullName ? 'XXX' : '',
      };
    case 'email':
    case 'phone':
    case 'message':
      if (isError) {
        return {
          [name]: parseError(fields[name]),
        };
      }
      return {
        [name]: fields[name] ? 'XXX' : '',
      };
    case 'timeFrom':
    case 'timeTo':
      return {
        time: isError ? fields.timeFrom || fields.timeTo : [fields.timeFrom, fields.timeTo],
      };
    case 'flexibleOnTime':
      return {
        flexible: parseError(fields[name]),
      };
    case 'catering':
      return {
        catering: parseError(fields.catering?.requireCatering),
        externalCatering: parseError(fields.catering?.ownCatering),
        cateringOptions: {
          ...Object.keys(emptyCateringOptions).reduce((acc, el) => ({
            ...acc,
            [el]: parseError(fields.catering?.[el]),
          }), {}),
        },
      };
    default:
      return {
        [name]: parseError(fields[name]),
      };
  }
};

const fieldMapping = ({ fields, isError = false }) => (
  Object.keys(fields).reduce((acc, name) => ({
    ...acc,
    ...mapField(name, fields, isError),
  }), {})
);

const getState = ({
  state,
  errors = {},
  values = {},
}) => {
  const { dateAndPeople, messageAndCatering, userInfo } = state.form;
  return {
    roomId: state.room.id,
    // step: state.step,
    form: {
      date: dateAndPeople.date || '',
      eventType: dateAndPeople.eventType || '',
      eventTypeSlug: dateAndPeople.eventType || '',
      flexible: !!dateAndPeople.flexibleOnTime,
      people: dateAndPeople.people || '',
      layout: state.form.dateAndPeople.layout || '',
      time: [dateAndPeople.timeFrom, dateAndPeople.timeTo],

      message: messageAndCatering.message ? 'XXX' : '',
      catering: messageAndCatering.catering.requireCatering,
      externalCatering: messageAndCatering.catering.externalCatering,
      cateringOptions: Object.keys(emptyCateringOptions).reduce((acc, el) => ({
        ...acc,
        [el]: messageAndCatering.catering[el].value,
      }), {}),

      name: userInfo.fullName ? 'XXX' : '',
      email: userInfo.email ? 'XXX' : '',
      phone: userInfo.phone ? 'XXX' : '',
      ...fieldMapping({ fields: values }),
    },
    errors: {
      capacity_exceeded: false,
      time: false,
      date: false,
      people: false,
      catering: false,
      catering_options: false,
      external_catering: false,
      name: false,
      email: false,
      ...fieldMapping({ fields: errors, isError: true }),
    },
  };
};

export default {
  trackEnquiry({ state }, action) {
    App.components.enquiry_tracking(
      `room-${action}`,
      state.user.isLoggedIn,
      'Enquire Now',
    );
  },

  trackEnquiryFormAction({ state, getters }, {
    action,
    label,
    errors = {},
    values = {},
  }) {
    const value = getState({ state, getters, errors, values });

    App.track.all({
      category: 'enquiry-form',
      action,
      label,
      value: JSON.stringify(value),
    });
  },

  trackEnquiryFormFirstInteraction({ dispatch }, dataTestId) {
    let label = '';
    switch (dataTestId) {
      case 'enquiry-form__mobile-enquire-btn':
        label = 'mobile-button';
        break;
      case 'enquiry-form__event-type':
        label = 'room_tag_autocomplete';
        break;
      case 'enquiry-form__date':
        label = 'date';
        break;
      case 'enquiry-form__people':
        label = 'people';
        break;
      case 'enquiry-form__time-from':
        label = 'time-from';
        break;
      case 'enquiry-form__time-to':
        label = 'time-to';
        break;
      case 'enquiry-form__time-to2':
        label = 'flexible';
        break;
      case 'enquiry-form__date-and-ppl-btn':
        label = 'enquire_now';
        break;
      case 'message-host-btn':
        label = 'message_host';
        break;
      default:
        break;
    }
    dispatch('trackEnquiryFormAction', {
      action: 'first-interaction',
      label,
    });

    window.dataLayer.push({
      event: 'RoomPageRequestToBookAndMessageHost-first-interaction', // only for triggering HotJar (e.g. in RtB exp)
    });
  },

  trackEnquiryFormValueChange({ dispatch }, { label, errors, values }) {
    dispatch('trackEnquiryFormAction', {
      action: 'value-change',
      label,
      errors,
      values,
    });
  },

  trackEnquiryFormNavigation({ dispatch }, { label, errors, values }) {
    dispatch('trackEnquiryFormAction', {
      action: 'navigation-button',
      label,
      errors,
      values,
    });
  },

  trackEnquiryFormBackNavigation({ dispatch }, { label, errors, values }) {
    dispatch('trackEnquiryFormAction', {
      action: 'back-navigation',
      label,
      errors,
      values,
    });
  },
};
